import { Components, Theme } from '@mui/material/styles';
import { getFocusRingStyle } from '@/src/components/focusring/focusring';
import { FormControl } from './FormControl';

export const flowFormControl: Components<Theme>['MuiFormControl'] = {
  defaultProps: {
    variant: 'filled',
    component: FormControl,
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      color: theme.palette.mode === 'dark' ? theme.palette.onSurface.os200 : theme.palette.onSurface.os600,
      // match original transition with inputLabel
      transition: theme.transitions.create(['color', 'transform'], {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut,
      }),
      // space for helperText (height + top margin + bottom margin)
      marginBottom: `${16 + 4 + 4}px`,
      '&:hover, &:has(.Mui-focused)': {
        color: theme.palette.text.primary,
      },
      '&:has(.Mui-error)': {
        '&:not(:has(.Mui-disabled)), &:has(.Mui-focused)': {
          '& .MuiInputLabel-root': {
            color: theme.palette.error.main,
          },
        },
      },
      '&:has(.Mui-disabled)': {
        color: theme.palette.disabled.tertiary,
      },
      borderRadius: '4px',
      // focus ring, appears with focused input
      ...getFocusRingStyle(theme, false, 0, '&:not(.Flow-NoFocusRing):has(.Mui-focused)'),
      // contains helper text
      '&:has(.MuiFormHelperText-root)': {
        // focused input
        '&:has(.Mui-focused)': {
          // does not have interactive error
          '&:not(:has(.FlowHelperText-error-button-active))': {
            // focus ring
            '&&:before': {
              // increase space (original size, helper text size + margin)
              bottom: `-${2 + 16 + 4 + 4}px`,
            },
          },
        },
      },
      // contains label
      '&:has(.MuiInputLabel-root)': {
        // focused OutlinedInput
        '&:has(.MuiOutlinedInput-root.Mui-focused)': {
          // focus ring
          '&&:before': {
            top: '-8px',
          },
        },
      },
      // select with open menu
      '&:has(.MuiSelect-select[aria-expanded="true"])': {
        // hide focus ring to keep just one in menu
        '&&:before': {
          boxShadow: 'none',
        },
      },
      // Checkboxes, Switches or Radio groups
      '&:has(.MuiFormGroup-root), &:has(.MuiRadioGroup-root)': {
        borderRadius: '0',
        marginBottom: '0',
        // remove focus effect
        '&&:before': {
          content: 'none',
        },
        // error
        ...(ownerState.error && {
          // similar style to banner
          borderLeft: `6px solid ${theme.palette.error.main}`,
          paddingLeft: '16px',
        }),
      },
    }),
  },
};
